import { LoadableLazy } from '@confluence/loadable';

export const GrantAccessFlagLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GrantAccessFlag" */ '../src/GrantAccessFlag.tsx'))
			.GrantAccessFlag,
});
